// extracted by mini-css-extract-plugin
export default {"main":"_0ba08bc7e0","tit":"b2dca57cc3","maintitle":"_5d5a3f406c","ylw":"f87bda82e7","white":"_0d0f538ae9","mv_title":"_421e26ba2f","mv_nc":"_5f1dd592fe","mv_in":"_971384460b"};